import { UntypedFormGroup } from '@angular/forms';
import { Model } from '../base.model';

export enum TireWheelType {
  Tires = 'tires',
  Wheels = 'wheels',
}

export class TireWheel extends Model {
  description: string;
  radius: string;
  weight: number;
  type: TireWheelType;
  isTruck = false;
}

export interface TireWheelModel {
  [key: string]: { label: string; id: string; fg: UntypedFormGroup };
}
